export default "__VITE_ASSET__DzModDxc__"